import request from '@/utils/request'
// 登录
export const apiLogin = (params) => {
  return request({
    url: '/admin/user/adminLogin',
    method: 'POST',
    data: params,
    headers:{'content-type':"application/json"}
  })
}
// 登出
export const apiLoginOut = (params) => {
  return request({
    url: '/admin/user/adminLogout',
    method: 'POST',
    data: params,
    headers:{'content-type':"application/json"}
  })
}
//获取用户信息
export const apiQueryUser = (params) => {
  return request({
    url: '/admin/user/queryUser',
    method: 'POST',
    data: params,
    headers:{'content-type':"application/x-www-form-urlencoded"}
  })
}
// 修改用户信息
export const apiUpdateUser = (params) => {
  return request({
    url: '/admin/user/updateUser',
    method: 'POST',
    data: params,
    headers:{'content-type':"application/json"}
  })
}
// 修改密码
export const apiUpdatePwd = (params) => {
  return request({
    url: '/admin/user/updatePwd',
    method: 'POST',
    data: params,
    headers:{'content-type':"application/x-www-form-urlencoded"}
  })
}
// 获取所有标签
export const apiGetAllLabel = (params) =>{
  return request({
    url: '/admin/queryAllLabels',
    method: 'POST',
    data: params,
    headers:{'Content-Type': 'multipart/form-data'},
  })
}
// 修改标签和备注
export const addTagAndRemark = (params) => {
  return request({
    url: '/admin/addLabel',
    method: 'POST',
    data: params,
    headers:{'content-type':"application/json"},
  })
}
// 获取常用语
export const queryCommonWords = (params) => {
  return request({
    url: '/admin/queryCommonWords',
    method: 'GET',
    data: params,
    headers:{'content-type':"application/x-www-form-urlencoded"}
  })
}
// 添加常用语
export const addCommonWords = (params) => {
  return request({
    url: '/admin/addCommonWord',
    method: 'POST',
    data: params,
    headers:{'content-type':"application/x-www-form-urlencoded"}
  })
}
// 更新常用语
export const updateCommonWords = (params) => {
  return request({
    url: '/admin/updateCommonWord',
    method: 'POST',
    data: params,
    headers:{'content-type':"application/x-www-form-urlencoded"}
  })
}
// 删除常用语
export const deleteCommonWords = (params) => {
  return request({
    url: '/admin/delCommonWord',
    method: 'POST',
    data: params,
    headers:{'content-type':"application/x-www-form-urlencoded"}
  })
}
// 简历不通过
export const noPassVita = (params) => {
  return request({
    url: '/admin/resume/audit',
    method: 'POST',
    data: params,
    headers:{'content-type':"application/x-www-form-urlencoded"}
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js